import { render, staticRenderFns } from "./DetallePTIVisible.vue?vue&type=template&id=2a1620c5&scoped=true"
import script from "./DetallePTIVisible.vue?vue&type=script&lang=js"
export * from "./DetallePTIVisible.vue?vue&type=script&lang=js"
import style0 from "./DetallePTIVisible.vue?vue&type=style&index=0&id=2a1620c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1620c5",
  null
  
)

export default component.exports